import { render, staticRenderFns } from "./CustomerContract.vue?vue&type=template&id=530dfe9d&scoped=true&"
import script from "./CustomerContract.vue?vue&type=script&lang=js&"
export * from "./CustomerContract.vue?vue&type=script&lang=js&"
import style0 from "./CustomerContract.vue?vue&type=style&index=0&id=530dfe9d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530dfe9d",
  null
  
)

export default component.exports